import React from "react";

import { graphql, useLazyLoadQuery, useMutation } from "react-relay";

import { TVTeamScheduleEditAssigneesPopoverQuery } from "./__generated__/TVTeamScheduleEditAssigneesPopoverQuery.graphql";
import { TVTeamScheduleEditAssigneesPopoverMutation } from "./__generated__/TVTeamScheduleEditAssigneesPopoverMutation.graphql";
import { AssigneesPopover } from "@/src/components/TVAssigneesPopover";

type TeamScheduleEditAssigneesPopoverProps = {
  routineId: string;
  sequenceNumber: number;
  routineOccasionId: string;
  visible: boolean;
  onClose: () => void;
};

export function TVTeamScheduleEditAssigneesPopover(
  props: TeamScheduleEditAssigneesPopoverProps
) {
  const data = useLazyLoadQuery<TVTeamScheduleEditAssigneesPopoverQuery>(
    graphql`
      query TVTeamScheduleEditAssigneesPopoverQuery(
        $id: ID!
        $visible: Boolean!
      ) {
        routineOccasion(id: $id) @include(if: $visible) {
          ...TVAssigneesPopover_assignable
          assignedRoles {
            role {
              id
              ...TVAssigneesPopover_roles
            }
          }
        }
      }
    `,
    {
      id: props.routineOccasionId,
      visible: props.visible,
    }
  );
  const [updateAssignees, loading] =
    useMutation<TVTeamScheduleEditAssigneesPopoverMutation>(graphql`
      mutation TVTeamScheduleEditAssigneesPopoverMutation(
        $routineId: ID!
        $sequenceNumber: Int!
        $employeeIds: [ID!]!
      ) {
        routine(id: $routineId) {
          occasion(sequenceNumber: $sequenceNumber) {
            updateAssignedEmployees(employeeIds: $employeeIds) {
              id
              assigned {
                id
                employee {
                  id
                }
              }
            }
          }
        }
      }
    `);

  if (!data.routineOccasion) {
    return null;
  }
  return (
    <AssigneesPopover
      key={props.visible ? "visible" : "hidden"}
      assignable={data.routineOccasion}
      visible={props.visible}
      onClose={props.onClose}
      roles={data.routineOccasion.assignedRoles.map((ar) => ar.role)}
      assignedRoleIds={data.routineOccasion.assignedRoles.map((ar) => ar.role.id)}
      rolesLocked
      setAssignEmployeeIds={(selectedAssigneeIds) => {
        updateAssignees({
          variables: {
            routineId: props.routineId,
            sequenceNumber: props.sequenceNumber,
            employeeIds: selectedAssigneeIds,
          },
          optimisticResponse: {
            routine: {
              occasion: {
                updateAssignedEmployees: {
                  id: props.routineOccasionId,
                  assigned: selectedAssigneeIds.map((id) => ({
                    id: id + "-optimistic",
                    employee: { id },
                  })),
                },
              },
            },
          },
        });
      }}
    />
  );
}
